import { render, staticRenderFns } from "./XImage.vue?vue&type=template&id=984679bc&scoped=true"
import script from "./XImage.vue?vue&type=script&lang=js"
export * from "./XImage.vue?vue&type=script&lang=js"
import style0 from "./XImage.vue?vue&type=style&index=0&id=984679bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984679bc",
  null
  
)

export default component.exports